null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.22/scalalib/overrides-2.12/scala/collection/immutable/NumericRange.scala